module.exports = __webpack_public_path__ + "img/routes.2156b52b.svg";